// 导航栏 判断下拉是否在可视窗口内问题修复js ---- 开始
(function () {
  const GAP = 8;

  function getViewportW() {
    return document.documentElement.clientWidth;
  }

  function applyFlipForLv1(li) {
    const submenu = li.querySelector(':scope > ul.header__submenu.list-menu--disclosure-1');
    if (!submenu) return;

    // 清理旧状态
    li.classList.remove('menu-drop-align-right');

    // 关键：opacity 隐藏也能测量，所以直接 getBoundingClientRect
    const w = getViewportW();
    const r = submenu.getBoundingClientRect();
    const overflowRight = r.right > w - GAP;

    if (overflowRight) li.classList.add('menu-drop-align-right');
  }
  function applyFlipForLv2(li) {
    const submenu = li.querySelector(':scope > .site-nav-list-dropdown > ul.header__submenu.list-menu--disclosure-2');
    if (!submenu) return;
    // 清理旧状态
    submenu.classList.remove('menu-drop-align-right');

    // 关键：opacity 隐藏也能测量，所以直接 getBoundingClientRect
    const w = getViewportW();
    const r = submenu.getBoundingClientRect();
    const overflowRight = r.right > w - GAP;

    if (overflowRight) submenu.classList.add('menu-drop-align-right');
  }
  // 二级菜单, menu-lv-item menu-lv-2 text-left  dropdown  menu-lv-blink
  function run() {
    document
      .querySelectorAll('li.halo-wrapper.menu-lv-1.dropdown')
      .forEach(applyFlipForLv1);
    
    document
      .querySelectorAll('li.menu-lv-item.menu-lv-2.dropdown.menu-lv-blink')
      .forEach(applyFlipForLv2);
  }

  

  // 新增监听宽度变化逻辑
  let t = null;
  function scheduleRun() {
    clearTimeout(t);
    t = setTimeout(run, 80);
  }

  // 监听 .main-menu--wrapper 宽度变化（元素级别 resize）
  function observeMainMenuWrapper() {
    const el = document.querySelector('.main-menu--wrapper');
    if (!el) return;

    let lastW = Math.round(el.getBoundingClientRect().width);

    if (!('ResizeObserver' in window)) return;

    const ro = new ResizeObserver(() => {
      const w = Math.round(el.getBoundingClientRect().width);
      if (w !== lastW) {
        lastW = w;
        scheduleRun();
      }
    });

    ro.observe(el);
  }

  // 初始化（等一帧，避免字体/图片导致布局还没稳定）
  window.addEventListener('DOMContentLoaded', () => requestAnimationFrame(run));
  window.addEventListener('resize', scheduleRun);
  window.addEventListener('DOMContentLoaded', observeMainMenuWrapper);

})();

// 导航栏 判断下拉是否在可视窗口内问题修复js ---- 结束